import "UI/Widget/Base";
import "System/NumSeq";
NS("UI.Widget");

UI.Widget.List = Class(UI.Widget.Base, {
    itemTemplate: null,

    items: [],
    elements: [],
    index: {},
    selected: {},

    filterCallback: null,

    selectedClass: "selected",
    listItemClass: "ui-widget-list",

    $list: null,

    visibleItems: {},

    navigationContainer: null,
    navigationKey: null,
    navigationListener: null,
    navigationOptions: null,

    initialize: function(parent, options) {
        this.Parent(parent, options);

        this.$list = this.$element;
    },

    destroy: function() {
        this.navigationStop();

        this.items = [];
        this.elements = [];
        this.index = {};
        this.selected = {};
        this.$list = null;
        this.visibleItems = {};
        this.navigationContainer = null;

        return this.ParentCall();
    },

    render: function() {
        this.ParentCall();

        this.$list = this.$element;

        return this;
    },

    refresh: function() {
        this.update(this.items);

        return this;
    },

    update: function(items) {
        var self = this;
        var length = items.length;
        var gridLength = this.items.length;
        var maxLength = Math.max(length, gridLength);
        var i, count;

        for (i = 0, count = Math.min(length, gridLength); i < count; i++) {
            this.updateItem(items[i], i);
        }

        if (length < gridLength) {
            for (i = length; i < gridLength; i++) {
                this.removeItem(null, length);
            }
        } else if (length > gridLength) {
            for (i = gridLength; i < length; i++) {
                this.insertItem(items[i], i);
            }
        }

        this.updateIndex();

        this.emit("update");

        return this;
    },

    clear: function() {
        for (var i = this.elements.length - 1; i >= 0; i--) {
            this.elements[i].remove();
        }

        this.elements = [];
        this.items = [];
        this.index = {};

        return this;
    },

    /**
     *
     * @param {Object} item
     * @param {String} [mode] "single", "multiple"
     * @param {Object} [options]
     */
    selectItem: function(item, mode, options) {
        mode = Util.coalesce(mode, "single");

        options = Util.defaults({
            "class": this.selectedClass,
            "deselect": true
        }, options);

        if (!Util.isArray(options["class"])) {
            options["class"] = options["class"] ? options["class"].split(" ") : [];
        }

        if (options["class"].length) {
            if (mode == "single" && options["deselect"]) {
                this.deselectItem(null, options);
            }

            var index = this.getItemIndex(item);
            var key = this.indexKey(item);

            if (~index) {
                if (this.selected[key] && options["deselect"]) {
                    // this.deselectItem(item, null);
                    return;
                } else {
                    var $element = this.elements[index];

                    $element.addClass(options["class"].join(" "));

                    var classes = this.selected[key];

                    if (classes) {
                        classes = classes.concat(options["class"]);
                    } else {
                        classes = options["class"];
                    }

                    this.selected[key] = Util.Array.unique(classes);
                }
            }
        }
    },

    deselectItem: function(item, options) {
        var self = this;

        options = Util.defaults({
            "class": this.selectedClass
        }, options);

        if (!Util.isArray(options["class"])) {
            options["class"] = options["class"] ? options["class"].split(" ") : [];
        }

        if (options["class"].length) {
            if (item) {
                var index = this.getItemIndex(item);
                var key = this.indexKey(item);

                if (~index) {
                    var $element = this.elements[index];
                    var classes = this.selected[key];

                    if (classes) {
                        if (options["class"].length == 1 && options["class"][0] == "*") {
                            $element.removeClass(classes.join(" "));
                            classes = [];
                        } else {
                            $element.removeClass(options["class"].join(" "));
                            classes = Util.Array.diff(classes, options["class"]);
                        }

                        if (classes.length) {
                            this.selected[key] = classes;
                        } else {
                            delete this.selected[key];
                        }
                    }
                }
            } else {
                Util.each(this.selected, function(classes, key) {
                    var item = self.keyItem(key);

                    if (item) {
                        self.deselectItem(item, options);
                    }
                });
            }
        }
        this.emit("deselectItem", item);
    },

    createItem: function(item) {
        var $item = UI.Template.$render(this.setting("itemTemplate"), {
            item: item,
            widget: this
        });

        $item.addClass(this.listItemClass);
        $item.data("index-key", this.indexKey(item));

        return $item;
    },

    getItemIndex: function(object) {
        //return this.indexOf(object);
        return this.getIndex(object);
    },

    getItem: function(object) {
        var index = this.getItemIndex(object);

        return ~index ? this.items[index] : null;
    },

    findItem: function(object) {
        for (var i = 0; i < this.items.length; i++) {
            if (Util.equal(object, this.items[i])) {
                return this.items[i];
            }
        }

        return null;
    },

    getElementItem: function(element) {
        var index = this.indexOfElement(element);

        return ~index ? this.items[index] : null;
    },

    insertItem: function(item, index) {
        var $element = this.createItem(item);
        var self = this;
        if (index == 0) {
            if (this.elements.length) {
                $element.insertBefore(this.elements[0]);
            } else {
                $element.appendTo(this.$list);
            }

            this.items.unshift(item);
            this.elements.unshift($element);
        } else if (index < this.elements.length) {
            $element.insertBefore(this.elements[0]);

            this.items.splice(index, 0, item);
            this.elements.splice(index, 0, $element);
        } else {
            index = this.items.length;

            $element.appendTo(this.$list);
            // if  (item.options && item.options.dictid) {
            //     $element.find(".button.icon-arrow-right.next_item_btn").on("click", function () {
            //         self.emit('nextItemSelect', item);
            //     })
            // }
            this.items.push(item);

            this.elements.push($element);
        }

        this.appendIndex(item, index);

        this.refilter(item, index);

        return $element;
    },

    updateItem: function(item, index, dataOnly) {
        if (index === undefined) {
            index = this.getItemIndex(item);
        }

        if (this.elements[index] === undefined) {
            return null;
        }

        if (!dataOnly) {
            var $element = this.createItem(item);
            var element = this.elements[index];

            element.replaceWith($element);
            element.remove();
            this.elements[index] = $element;
        }

        this.removeIndex(this.items[index], false);

        this.items[index] = item;

        this.appendIndex(item, index, false);

        this.refilter(item, index);

        return $element;
    },

    removeItem: function(item, index) {
        if (index === undefined) {
            index = this.getItemIndex(item);
        }

        if (this.elements[index] === undefined) {
            return null;
        }

        if (!item) {
            item = this.items[index];
        }

        var key = this.indexKey(item);

        this.showItem(item, index);

        var element = this.elements[index];

        this.removeIndex(item, false);

        this.elements.splice(index, 1);
        this.items.splice(index, 1);

        element.remove();

        this.updateIndex(index);

        delete this.selected[key];
        delete this.visibleItems[key];

        return true;
    },

    showItem: function(item, index) {
        if (index === undefined) {
            index = this.getItemIndex(item);
        }

        var element = this.elements[index];

        if (element === undefined) {
            return false;
        }

        var display = element.css("display");

        if (display == "none") {
            element.css("display", "");
        }

        this.visibleItems[this.indexKey(item)] = true;

        return true;
    },

    hideItem: function(item, index) {
        if (index === undefined) {
            index = this.getItemIndex(item);
        }

        var element = this.elements[index];

        if (element === undefined) {
            return false;
        }

        var display = element.css("display");

        if (display != "none") {
            element.css("display", "none");
        }

        delete this.visibleItems[this.indexKey(item)];

        return true;
    },

    prependItem: function(item) {
        return this.insertItem(item, 0);
    },

    appendItem: function(item) {
        return this.insertItem(item);
    },

    setItem: function(item, callback, dataOnly) {
        var ret = null;
        var index = this.getItemIndex(item);

        if (~index) {
            ret = this.updateItem(item, index, dataOnly);
        } else {
            if (Util.isFunction(callback)) {
                index = this.getIndexFor(callback);

                ret = this.insertItem(item, index);
            } else {
                if (Util.isObject(callback)) {
                    var options = callback;

                    if (options.prepend) {
                        ret = this.prependItem(item);
                    } else if (options.append) {
                        ret = this.appendItem(item);
                    }
                }

                if (!ret) {
                    ret = this.insertItem(item);
                }
            }
        }

        return ret;
    },

    setFilter: function(callback) {
        this.filterCallback = Util.isFunction(callback) ? callback : null;

        return this;
    },

    hasFilter: function() {
        return this.filterCallback !== null;
    },

    refilter: function(item, index) {
        var self = this;
        var items;

        if (item) {
            items = {};
            items[index] = item;
        } else {
            items = this.items;
        }

        if (this.hasFilter()) {
            Util.each(items, function(item, index) {
                if (self.filterCallback.call(self, item)) {
                    self.showItem(item, index);
                } else {
                    self.hideItem(item, index);
                }
            });
        } else {
            if (item) {
                this.showItem(item, index);
            } else {
                this.showItems();
            }
        }

        if (this.navigationListener) {
            if (this.navigationKey) {
                if (!this.visibleItems[this.navigationKey]) {
                    this.deselectItem();
                    this.navigationKey = null;
                }
            }
        }

        return this;
    },

    filterItems: function(callback) {
        var self = this;

        this.setFilter(callback);

        this.refilter();

        return this;
    },

    showItems: function() {
        var self = this;

        this.filterCallback = null;

        Util.each(this.items, function(item, index) {
            self.showItem(item, index);
        });

        return this;
    },

    getTotalCount: function() {
        return Object.keys(this.items).length;
    },

    getVisibleCount: function() {
        return Object.keys(this.visibleItems).length;
    },

    getIndexFor: function(callback) {
        var length = this.items.length;

        if (!length) {
            return 0;
        }

        for (var i = 0; i < length; i++) {
            if (callback(this.items[i])) {
                return i;
            }
        }

        return length;
    },

    indexOf: function(item) {
        for (var i = 0; i < this.items.length; i++) {
            if (this.indexOfCheck(item, this.items[i])) {
                return i;
            }
        }

        return -1;
    },

    indexOfElement: function(element) {
        element = $(element);

        if (!element.hasClass(this.listItemClass)) {
            element = element.parents("." + this.listItemClass).first();
        }

        if (!element.length) {
            return -1;
        }

        var key = element.data("index-key");

        if (Util.isDefined(key)) {
            var index = this.index[key];

            if (index !== undefined) {
                return index;
            }
        } else {
            element = element[0];

            for (var i = 0; i < this.elements.length; i++) {
                if (this.elements[i][0] == element) {
                    return i;
                }
            }
        }

        return -1;
    },

    indexOfCheck: function(item, listItem) {
        return this.indexKey(item) == this.indexKey(listItem);
    },

    indexKey: function(item) {
        return item.id;
    },

    keyItem: function(key) {
        return this.items[this.index[key]];
    },

    getIndex: function(item) {
        var index = this.index[this.indexKey(item)];

        return index !== undefined ? index : -1;
    },

    getElement: function(item) {
        var index = this.getIndex(item);

        if (~index) {
            return this.elements[index];
        }

        return null;
    },

    appendIndex: function(item, index, update) {
        update = Util.coalesce(update, true);

        this.index[this.indexKey(item)] = index;

        if (update) {
            this.updateIndex(index);
        }
    },

    removeIndex: function(item, update) {
        update = Util.coalesce(update, true);

        var index = this.getIndex(item);

        delete this.index[this.indexKey(item)];

        if (update && Util.isDefined(index)) {
            this.updateIndex(index);
        }

        return index;
    },

    updateIndex: function(from) {
        var items = this.items;
        from = Util.coalesce(from, 0);

        for (var i = from, count = items.length; i < count; i++) {
            this.appendIndex(items[i], i, false);
        }
    },

    navigationStart: function(options) {
        var self = this;

        this.navigationOptions = Util.object(options);

        if (!this.navigationListener) {
            this.navigationListener = function(args) {
                var index;
                var item;
                var key;

                if (Util.isFunction(self.navigationOptions.enabled)) {
                    if (!self.navigationOptions.enabled()) {
                        return;
                    }
                }

                switch (args.keyCode) {
                    case KeyCode.Down:
                        if (args.ctrlKey || args.altKey || args.shiftKey) {
                            return;
                        }

                        if (!Util.isDefined(self.navigationKey)) {
                            index = -1;
                        } else {
                            index = self.index[self.navigationKey];
                        }

                        if (Util.isDefined(index)) {
                            while (index < self.items.length - 1) {
                                index++;

                                item = self.items[index];
                                key = self.indexKey(item);

                                if (self.visibleItems[key]) {
                                    self.navigationKey = key;
                                    break;
                                }
                            }
                        }

                        if (Util.isDefined(self.navigationKey)) {
                            item = self.keyItem(self.navigationKey);
                            self.selectItem(item);
                            self.navigateToItem(item);
                        }

                        args.preventDefault();
                        break;
                    case KeyCode.Up:
                        if (args.ctrlKey || args.altKey || args.shiftKey) {
                            return;
                        }

                        if (!Util.isDefined(self.navigationKey)) {
                            index = self.items.length;
                        } else {
                            index = self.index[self.navigationKey];
                        }

                        if (Util.isDefined(index)) {
                            while (index > 0) {
                                index--;

                                item = self.items[index];
                                key = self.indexKey(item);

                                if (self.visibleItems[key]) {
                                    self.navigationKey = key;
                                    break;
                                }
                            }
                        }

                        if (Util.isDefined(self.navigationKey)) {
                            item = self.keyItem(self.navigationKey);
                            self.selectItem(item);
                            self.navigateToItem(item);
                        }

                        args.preventDefault();
                        break;
                    case KeyCode.Enter:
                        if (args.ctrlKey || args.altKey || args.shiftKey) {
                            return;
                        }

                        if (Util.isDefined(self.navigationKey)) {
                            item = self.keyItem(self.navigationKey);

                            if (item) {
                                self.emit("navigation.select", {
                                    item: item,
                                    event: args
                                });
                            }
                        }

                        args.preventDefault();
                        break;
                }
            };

            $(window).on("keydown", this.navigationListener);
        }

        return this;
    },

    navigationStop: function() {
        if (this.navigationListener) {
            $(window).off("keydown", this.navigationListener);

            this.navigationListener = null;
        }

        return this;
    },

    navigateToItem: function(item) {
        var container = Util.coalesce(this.navigationContainer, this.element);
        var $container = $(container);
        var element = $(this.getElement(item));

        if (element.length) {
            var spaceHeight = $container.outerHeight();
            var height = element.outerHeight();
            var position = element.position();

            if (position.top + height > spaceHeight) {
                element[0].scrollIntoView(false);
            } else if (position.top < 0) {
                element[0].scrollIntoView();
            }
        }
    }
});

UI.Widget.List.Static({
    itemTemplate: null
});
